// Where a portrait is cut from a 320×480 walk cell (the figure is 400 px tall under 64 px of headroom).
// CROP = head and shoulders (friends panel); cropForAspect(w / h) keeps its top, left and width and grows it
// downwards to a taller frame (the driving licence's passport photo).
export const CROP = { x: 50, y: 34, w: 220, h: 220 };
export const cropForAspect = (aspect) => ({ ...CROP, h: Math.round(CROP.w / aspect) });

// The part of the cell scripts/anim/build_portrait_parts.py cuts out of every sheet (keep the two in step):
// every crop above must lie inside it.
export const PART = { x: 50, y: 34, w: 220, h: 300 };
export const fitsPart = (c) => c.x >= PART.x && c.y >= PART.y && c.x + c.w <= PART.x + PART.w && c.y + c.h <= PART.y + PART.h;
